import { useEffect, useState } from "react";

const toMinutes = (hhmm, fallback) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec((hhmm || "").trim());
  if (!m) return fallback;
  return Math.min(23, Number(m[1])) * 60 + Math.min(59, Number(m[2]));
};

const nowInIST = () => {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
  const h = Number(parts.find((p) => p.type === "hour")?.value || 0) % 24;
  const m = Number(parts.find((p) => p.type === "minute")?.value || 0);
  return h * 60 + m;
};

export const isWithinCallHours = (start, end, now = nowInIST()) => {
  const s = toMinutes(start, 9 * 60);
  const e = toMinutes(end, 17 * 60 + 30);
  return s <= e ? now >= s && now < e : now >= s || now < e;
};

export function useCallHours(start, end) {
  const [open, setOpen] = useState(() => isWithinCallHours(start, end));
  useEffect(() => {
    const tick = () => setOpen(isWithinCallHours(start, end));
    tick();
    const t = setInterval(tick, 30000);
    return () => clearInterval(t);
  }, [start, end]);
  return open;
}

export const formatHours = (start, end) => {
  const f = (v, fb) => { const mins = toMinutes(v, fb); const h = Math.floor(mins / 60); const m = mins % 60; const ampm = h >= 12 ? "PM" : "AM"; return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${ampm}`; };
  return `${f(start, 9 * 60)} – ${f(end, 17 * 60 + 30)} IST`;
};
